import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"600\",\"700\",\"800\"],\"variable\":\"--font-sora\"}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/legal/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DpaInfoBanner","default"] */ "/vercel/path0/src/components/legal/dpa-gate-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionBanner"] */ "/vercel/path0/src/components/version-banner.tsx");
